import { render, staticRenderFns } from "./sendBack.vue?vue&type=template&id=35f7083f&scoped=true"
import script from "./sendBack.vue?vue&type=script&lang=js"
export * from "./sendBack.vue?vue&type=script&lang=js"
import style0 from "./sendBack.vue?vue&type=style&index=0&id=35f7083f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f7083f",
  null
  
)

export default component.exports